<template lang="pug">
  div
    doc-markdown(source=`
    ## Profiling Tally Counter \`profiling-tally-counter\`
    Intermediary wrapper between our profiling Sections and a combination of \`sw-input\` and \`sw-button\` generic components, assembled in a custom tally counter. Handles styles and error management.
    `)

    doc-preview(vue=`
    profiling-tally-counter.py-2(
      v-model="amountOfFounders"
      :error="error"
      class='w-1/4'
      data-purpose-prop="founders_counter"
      description="How many founders created Seraphin ?"
      :min-value=0
      :max-value=10
      @decrement="amountOfFounders--"
      @increment="amountOfFounders++"
      @blur="displayError = true"
      @focus="displayError = false"
      @keydown.enter.native="$event.target.blur()"
    )

    <script>
        ...
        data () {
          return {
            amountOfFounders: 0,
            displayError: false,
          };
        },
        computed: {
          error () {
            return this.displayError && this.amountOfFounders !== 2; },
        },
      };
    </script>
    `)
      profiling-tally-counter.py-2(
        v-model="amountOfFounders"
        :error="error"
        class='w-1/4'
        data-purpose-prop="founders_counter"
        description="How many founders created Seraphin ?"
        :min-value=0
        :max-value=10
        @decrement="amountOfFounders--"
        @increment="amountOfFounders++"
        @blur="displayError = true"
        @focus="displayError = false"
        @keydown.enter.native="$event.target.blur()"
      )

    doc-markdown(source=`
    ### Properties
    #### Props used in the intermediary component:
  | Props                | Description                                                          | Type           | Default |
  |----------------------|----------------------------------------------------------------------|----------------|---------|
  | \`value\` (v-model)  | Chosen value to which the tally counter is binded.	                  | String, Number | -       |
  | \`minValue\`         | Minimum value allowed for decrement to occur     	                  | Number         | 0       |
  | \`maxValue\`         | Maximum value allowed for decrement to occur     	                  | Number         | 50      |
  | \`description\`      | Label displayed above the tally counter.                             | String         | -       |
  | \`error\`            | Whether the red error highlighting should be displayed or not.       | Boolean        | -       |
    `)

    doc-markdown(source=`
    ### Events
  | Event name | Description                                                             | Parameters | Usage  |
  |------------|-------------------------------------------------------------------------|:--:|----------------|
  | increment  | Triggered when the \`+\` button is clicked, unless at or below minValue | -  | \`@increment\` |
  | decrement  | Triggered when the \`-\` button is clicked, unless at or above maxValue | -  | \`@decrement\` |
  | blur       | Triggered on blur from input field at the center of the component.      | -  | \`@blur\`      |
  | focus      | Triggered when focusing the input field at the center of the component. | -  | \`@focus\`     |
    `)
</template>

<script>
  export default {
    data () {
      return {
        amountOfFounders: 0,
        displayError: false,
      };
    },
    computed: {
      error () {
        return this.displayError && this.amountOfFounders !== 2; },
    },
  };
</script>
